function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LogicalFieldTemplate = require('./logical.template');
var LOGICAL_OPERATORS = ['AND', 'OR', 'NOT', 'THEN'];
var LOGICAL_EXPLANATIONS = {
  AND: 'All conditions must be true.',
  OR: 'At least one condition must be true.',
  NOT: 'Inverts the result of a condition.',
  THEN: 'Execute the next condition only if the previous succeeds.'
};
function normalizeLogicalOperator(value) {
  var upper = String(value || '').trim().toUpperCase();
  return LOGICAL_OPERATORS.includes(upper) ? upper : 'AND';
}
function explainLogicalOperator(op) {
  return LOGICAL_EXPLANATIONS[normalizeLogicalOperator(op)] || '';
}
var LogicalFieldOverlay = /*#__PURE__*/function () {
  function LogicalFieldOverlay(app, mod) {
    _classCallCheck(this, LogicalFieldOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.currentValue = '';
    this.onApply = null;
  }
  return _createClass(LogicalFieldOverlay, [{
    key: "render",
    value: function render() {
      var current = normalizeLogicalOperator(this.currentValue || 'AND');
      var optionsHtml = LOGICAL_OPERATORS.map(function (op) {
        return "<option value=\"".concat(op, "\"").concat(op === current ? ' selected' : '', ">").concat(op, "</option>");
      }).join('');
      this.overlay.show(LogicalFieldTemplate(current, optionsHtml, explainLogicalOperator(current)));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _root$querySelector,
        _this = this;
      var host = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var root = host === null || host === void 0 ? void 0 : host.querySelector('.rs-prompt-logical');
      var select = root === null || root === void 0 ? void 0 : root.querySelector('.rs-prompt-logical-select');
      var title = root === null || root === void 0 ? void 0 : root.querySelector('.rs-overlay-title');
      var explainEl = root === null || root === void 0 ? void 0 : root.querySelector('.rs-prompt-logical-explain');
      if (!root || !select) {
        return;
      }
      select.focus({
        preventScroll: true
      });
      var updateExplain = function updateExplain() {
        var op = normalizeLogicalOperator(select.value);
        if (title) {
          title.textContent = op;
        }
        if (explainEl) {
          explainEl.textContent = explainLogicalOperator(op);
        }
      };
      select.addEventListener('change', updateExplain);
      (_root$querySelector = root.querySelector('.rs-prompt-apply')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        var op = normalizeLogicalOperator(select.value);
        if (typeof _this.onApply === 'function') {
          _this.onApply(op);
        }
        _this.overlay.hide();
      });
    }
  }]);
}();
module.exports = LogicalFieldOverlay;